import React from 'react';
import styles from './promotion.module.scss';


const PromotionComponent = ({ image, header, description }) => {
  return (
    <div className={styles.promotionalComponent}>
      <img src={image} alt="Promotion" className={styles.promotionalImage} />
      <div className={styles.promotionalText}>
        <h2 className={styles.promotionalHeader}>{header}</h2>
        <p className={styles.promotionalDescription}>{description}</p>
      </div>
    </div> 
  );
};

export default PromotionComponent;